import type { IAndroidBridgeNativeModule } from './AndroidBridge.types';

const AndroidBridgeModule: IAndroidBridgeNativeModule = {
  isBoldTextEnabled() {
    return false;
  },
};

export default AndroidBridgeModule;
